import React, { FC } from 'react'
import classNames from 'classnames'
import { FlexRow } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { EyebrowXS, ParagraphSM, TitleXXS } from '@/atoms/Text'
import { useGuildRatingBySlug } from '@/services/GuildRatingService/GuildRatingService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { ParentsGuideTooltip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ShowtimeDetailsPanel/ParentsGuide/ParentsGuideTooltip'

interface ParentsGuideProps {
  theatricalSlug: string
  className?: string
  popoverClassName?: string
}

export const ParentsGuide: FC<ParentsGuideProps> = ({ theatricalSlug, className, popoverClassName }) => {
  const { t } = useTranslate('tickets')
  const { rating } = useGuildRatingBySlug(theatricalSlug)

  if (!rating) return null

  const age = rating.ageText

  const trigger = (
    <FlexRow className={classNames('gap-1 items-center', className)}>
      <CircleInfoIcon color="core-warning-600" size={14} className="hidden md:block" />
      <CircleInfoIcon color="core-warning-600" size={12} className="md:hidden" />
      <EyebrowXS className="md:photon-eyebrow-sm underline" color="core-warning-600" weight="semibold">
        {t('parentsGuide', "Parent's Guide")}
      </EyebrowXS>
    </FlexRow>
  )
  const content = (
    <>
      <TitleXXS color="core-gray-950" weight="medium">
        <Translate i18nKey="guildRecommendedAgeTitle" t={t} values={{ age }}>
          <strong>{{ age }}</strong> (Guild Recommended Age)
        </Translate>
      </TitleXXS>
      <ParagraphSM className="mt-2 text-[0.688rem] leading-[16px]" color="core-gray-700">
        {rating.description}
      </ParagraphSM>
    </>
  )
  return <ParentsGuideTooltip trigger={trigger} content={content} className={popoverClassName} />
}
